import React from "react";
import { useParams, useLocation } from "react-router-dom";
import ChatContent from "/src/features/ai/llm-rag/components/chat/ChatContent";
import Page from "/src/layouts/page/Page";

function ChatPage({}) {
    const { chatId } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const brainId = queryParams.get("brainId");

    return (
        <Page>
            <ChatContent chatId={chatId} brainId={brainId} />
        </Page>
    );
}

export default ChatPage;
